import authHeader from "../../../../authentication/authservices/auth-header";
import storeGRN from "../../../../http-common";

export const getVerifyGrnList = (searchObj) => {
  return storeGRN.post(`/grn/grnList`, searchObj, {
    headers: authHeader(),
  });
};

export const getVerifyGrnItemDetailsList = (grnId, storeId) => {
  return storeGRN.get(`/grn/grnDetailsList/${grnId}/${storeId}`, {
    headers: authHeader(),
  });
};

export const postVerifyGrn = (menuId, privilege, postObj) => {
  return storeGRN.post(`/grn/verifyGrn/${menuId}/${privilege}`, postObj, {
    headers: authHeader(),
  });
};

export const getGrnInfoByGrnId = (grnId) => {
  return storeGRN.get(`/grn/grnInfo/${grnId}`, {
    headers: authHeader(),
  });
};

export const closeGrnForcefully = (grnId) => {
  return storeGRN.get(`/grn/cancelgrn/${grnId}`, {
    headers: authHeader(),
  });
};

// {
//     "GRNId": 1149047,
//     "GRNNumber": "GRPCR/104/0000031",
//     "StoreId": 61,
//     "StoreName": "MEDICAL RECORD",
//     "ItemId": 1613,
//     "ItemCode": "1613",
//     "ItemName": "ACILOC RD TAB",
//     "SupplierId": 63940,
//     "SupplierName": "A  TWO  Z TRADERS",
//     "InvoiceNo": "213564897",
//     "InvoiceDate": "2025-11-17T18:30:00.000+00:00",
//     "DCNumber": "",
//     "DCDate": "2025-11-17T18:30:00.000+00:00",
//     "DueDate": "2025-11-17T18:30:00.000+00:00",
//     "GateEntryNo": "231546897",
//     "GRNDetailId": 1514861,
//     "BatchCode": "JKAD22036",
//     "BatchExpiryDate": "2025-12-30T18:30:00.000+00:00",
//     "Conversion": 15,
//     "POId": 1477548,
//     "DCId": 0,
//     "POQty": 10,
//     "DCQty": 0,
//     "RectQty": 10,
//     "FreeQty": 0,
//     "AcceptQty": 10,
//     "PurchaseRate": 55,
//     "LandedNetRate": 58.52,
//     "UnitPurchaseRate": 55,
//     "MRP": 77,
//     "TaxAmount": 0,
//     "DiscPercent": 5,
//     "DiscAmount": 27.5,
//     "SchemeDiscAmt": 0,
//     "OctroiPer": 0,
//     "OctroiAmt": 0,
//     "VatPercentage": 12,
//     "VatAmount": 66,
//     "OtherTaxAmount": 0,
//     "NetAmount": 588.5,
//     "IsConsignment": false,
//     "Remarks": "",
//     "Specification": "",
//     "TotalReturnQty": 0,
//     "TotalUsedQty": 0
// }
